var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeServiceIcn1Svg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 36,
    viewBox: "0 0 40 36",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "home-service-icn_1.svg",
    clipPath: "url(#clip0_567_45854)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M35.4921 0.435547H4.42636C3.26498 0.437606 2.152 0.896426 1.33078 1.71139C0.509643 2.52638 0.0473364 3.63108 0.0452881 4.78376V30.3459C0.0473626 31.4986 0.509652 32.6032 1.33078 33.4182C2.15193 34.2333 3.26498 34.6921 4.42636 34.6941H35.4921C36.6535 34.6921 37.7665 34.2333 38.5878 33.4182C39.4088 32.6033 39.8712 31.4986 39.8732 30.3459V4.78376C39.8712 3.63108 39.4088 2.52645 38.5878 1.71139C37.7666 0.896419 36.6535 0.43758 35.4921 0.435547ZM37.218 30.3459C37.218 30.8004 37.0361 31.2359 36.7125 31.5571C36.3888 31.8782 35.95 32.0588 35.4921 32.0588H4.42635C3.9685 32.0588 3.52966 31.8782 3.20602 31.5571C2.88242 31.2359 2.70047 30.8004 2.70047 30.3459V10.9766H37.218V30.3459ZM37.218 8.34137H2.70048V4.78376C2.70048 4.32934 2.88243 3.89378 3.20604 3.57258C3.52964 3.2514 3.96854 3.07081 4.42637 3.07081H35.4921C35.95 3.07081 36.3888 3.2514 36.7125 3.57258C37.0361 3.89376 37.218 4.32936 37.218 4.78376V8.34137Z",
    fill: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.01299 5.70876C8.01299 6.4364 7.41854 7.0264 6.68539 7.0264C5.95225 7.0264 5.35779 6.4364 5.35779 5.70876C5.35779 4.98111 5.95225 4.39111 6.68539 4.39111C7.41854 4.39111 8.01299 4.98111 8.01299 5.70876Z",
    fill: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.9973 5.70876C11.9973 6.4364 11.4029 7.0264 10.6698 7.0264C9.93661 7.0264 9.34216 6.4364 9.34216 5.70876C9.34216 4.98111 9.93661 4.39111 10.6698 4.39111C11.4029 4.39111 11.9973 4.98111 11.9973 5.70876Z",
    fill: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M15.9777 5.70876C15.9777 6.4364 15.3832 7.0264 14.65 7.0264C13.9169 7.0264 13.3224 6.4364 13.3224 5.70876C13.3224 4.98111 13.9169 4.39111 14.65 4.39111C15.3832 4.39111 15.9777 4.98111 15.9777 5.70876Z",
    fill: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M16.8083 26.4032C17.0575 26.6503 17.395 26.7891 17.7471 26.7891C18.0991 26.7891 18.4366 26.6503 18.6856 26.4032L27.5365 17.6186C27.7929 17.3731 27.9386 17.0357 27.9419 16.6825C27.9449 16.329 27.805 15.9892 27.5531 15.7392C27.3012 15.4892 26.959 15.3504 26.6028 15.3533C26.2469 15.3563 25.9066 15.5013 25.6595 15.7554L17.747 23.6085L14.2605 20.1486C13.9234 19.8253 13.4395 19.7024 12.9872 19.8257C12.5354 19.9486 12.1821 20.2992 12.0579 20.748C11.9341 21.1965 12.0579 21.6771 12.3836 22.0118L16.8083 26.4032Z",
    fill: "#181818"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_567_45854",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 35.2941,
    fill: "#181818",
    transform: "translate(0 0.352905)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeServiceIcn1Svg);
export default __webpack_public_path__ + "static/media/home-service-icn_1.svg.49b136f1a9eabd6322a02f42b73e363f.svg";
export { ForwardRef as ReactComponent };